export const slideLeft = (id: string) => {
    const slider = document.getElementById(id) as HTMLElement;
    slider.scrollLeft = slider.scrollLeft - 300;
  };
  
  export const slideRight = (id: string) => {
    const slider = document.getElementById(id) as HTMLElement;
    slider.scrollLeft = slider.scrollLeft + 300;
  };
  